import { useNavigate } from "react-router-dom";
import { DocumentAddIcon, PencilIcon, LockClosedIcon, LockOpenIcon } from "@heroicons/react/solid";
import Tippy from "@tippyjs/react";
import "tippy.js/themes/light.css";
import "tippy.js/animations/shift-away-subtle.css";

import { BUTTON_VARIANT_TYPES, NO_ACCESS_TYPES, PERMISSIONS } from "../../../../utils/constants";

import Button from "../../../SharedComponents/Button";
import AccessControl from "../../../SharedComponents/AccessControl";

function UserRow(props) {
    const { item: user } = props;

    const navigate = useNavigate();

    const handleAssignAssessment = () => {
        navigate("/assessments/assign-assessment", {
            state: {
                user: user,
            },
        });
    };

    const handleGoToEditUser = () => {
        navigate("/users/edit-user", {
            state: {
                userIdentifier: user.userIdentifier,
            },
        });
    };

    const handleGoToEditUserAccount = () => {
        navigate("/users/edit-user", {
            state: {
                userIdentifier: user.userIdentifier,
                editOption: "Account",
            },
        });
    };

    return (
        <tr key={user.emailAddress}>
            <td className="px-4 py-3 whitespace-nowrap ">
                <div className="flex flex-row gap-4 items-center">
                    <div>
                        <div>
                            {user.isLocked ? (
                                <Tippy
                                    content={
                                        <span>
                                            This account is locked if you wish to unlock it please click on the lock
                                            icon to unlock this account
                                        </span>
                                    }
                                    className={"p-2 shadow rounded-md text-red-700 bg-red-100 text-sm"}
                                    arrow={false}
                                    animation={"shift-away-subtle"}
                                >
                                    <div className={"cursor-pointer"} onClick={handleGoToEditUserAccount}>
                                        <LockClosedIcon className="block h-4 w-4 text-red-600" />
                                    </div>
                                </Tippy>
                            ) : (
                                <LockOpenIcon className="block h-4 w-4 text-green-600" />
                            )}
                        </div>
                    </div>

                    <div>
                        <div className="text-sm font-medium text-indigo-900">{user.name}</div>
                        <div className="text-sm text-blue-gray-500 mt-1">{user.emailAddress}</div>
                    </div>
                </div>
            </td>
            <td className="px-4 py-3 whitespace-nowrap hidden lg:table-cell">
                <div className={"flex flex-row gap-3 items-center"}>
                    <div className={"text-xs font-medium text-secondary-600 bg-secondary-100 p-1 px-2 rounded-full"}>
                        {user.userGroups.length} user group(s)
                    </div>
                </div>
            </td>
            <td className="px-4 py-3 whitespace-nowrap hidden lg:table-cell">
                <AccessControl requiredPermission={PERMISSIONS.ASSIGN_ASSESSMENTS} noAccessType={NO_ACCESS_TYPES.BLANK}>
                    <Button
                        onClick={handleAssignAssessment}
                        iconPositionLeft
                        icon={<DocumentAddIcon className="block h-4 w-4 mr-2" />}
                        colour={BUTTON_VARIANT_TYPES.UNCOLOURED}
                        text="Assign assessment"
                        extraStyling="shadow-none text-secondary-600 p-0"
                    />
                </AccessControl>
            </td>
            <td className="px-4 py-3 whitespace-nowrap">
                <div className={"flex flex-row gap-3 items-center"}>
                    <Button
                        onClick={() => handleGoToEditUser(user)}
                        iconPositionLeft
                        icon={<PencilIcon className="block h-3.5 w-3.5 mr-2" />}
                        colour={BUTTON_VARIANT_TYPES.UNCOLOURED}
                        text="Edit"
                        extraStyling="shadow-none text-primary-600 p-0 focus:ring-0 focus:transparent"
                    />
                </div>
            </td>
        </tr>
    );
}

export default UserRow;
